import type { LocationStatus } from '@jq4race/shared';
import {
  getCurrencyOptions,
  getTimezoneOptions,
  ORG_NICHE_LABELS,
  ORG_NICHE_OPTIONS,
} from '@jq4race/shared';

// Timezone/currency options are sourced from the shared geo registry
// (packages/shared/src/geo) — only the United States is enabled today.

// Niche label/options are the shared source of truth (packages/shared/src/org-schemas.ts) —
// do not hardcode local maps here.
export const NICHE_LABEL = ORG_NICHE_LABELS;

export const STATUS_TONE: Record<LocationStatus, 'success' | 'secondary'> = {
  active: 'success',
  inactive: 'secondary',
};

export const NICHE_OPTIONS = ORG_NICHE_OPTIONS;

export const CURRENCY_OPTIONS: ReadonlyArray<{ value: string; label: string }> =
  getCurrencyOptions();

export const TIMEZONE_OPTIONS: ReadonlyArray<{ value: string; label: string }> =
  getTimezoneOptions();
